import e from"../../../utils/esm/deepmerge/deepmerge.js";function r(r,t){return t?e(r,t,{clone:!1}):r}export{r as default};
//# sourceMappingURL=merge.js.map
